import { IconType } from 'react-icons';

import Divider, { Orientation } from './Divider';
import Text from './Text';

interface AttributeTagProps {
  label: string;
  value: string;
  icon?: IconType;
}

const AttributeTag: React.FunctionComponent<AttributeTagProps> = ({
  label,
  value,
  icon: Icon,
}) => (
  <div
    className="px-4 py-2 bg-gray-100/70 flex items-center rounded-md border border-gray-300/80"
    tabIndex={0}
  >
    {Icon && <Icon className="text-gray-500" size={24} />}
    {Icon && <Divider orientation={Orientation.VERTICAL} />}
    <span className={`flex flex-col ${label === value ? 'py-3' : 'py-1'} `}>
      <Text
        text={label === value ? '' : label}
        className="text-gray-600/80 text-2xs md:text-xs lg:text-xs font-medium pb-1 truncate"
      />
      <Text
        text={value}
        className="text-gray-700/80 text-xs md:text-sm lg:text-sm font-semibold"
      />
    </span>
  </div>
);

export default AttributeTag;
